document.addEventListener('DOMContentLoaded', function() {
    // Detect if mobile/iOS
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
        // Disable parallax on mobile for better performance
        return;
    }
    
    const parallaxLayers = document.querySelectorAll('.leo-parallax-layer');
    let ticking = false;
    
    function updateParallax() {
        parallaxLayers.forEach(layer => {
            const scrolled = window.pageYOffset;
            const rect = layer.parentElement.getBoundingClientRect();
            const offset = rect.top + scrolled;
            const height = layer.parentElement.offsetHeight;
            
            if (scrolled + window.innerHeight > offset && scrolled < offset + height) {
                const yPos = (scrolled - offset) * 0.5;
                layer.style.transform = `translate3d(0, ${yPos}px, 0)`;
            }
        });
        ticking = false;
    }
    
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
        }
    });
});